import { render, staticRenderFns } from "./DraftPurchaseOrder.vue?vue&type=template&id=c4958514"
import script from "./DraftPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./DraftPurchaseOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports